// Generic client for the RSRH tool-results Airtable submission endpoint (backend/airtable/submit.php).
// Shared across all blocks/rsrh/*.tsx tools via the useToolSubmission hook (hooks/useToolSubmission.ts) —
// new tools don't need new endpoints or types here, just their own `fields`/`items` shape.

export interface ToolSubmissionPayload {
  tool: string
  sessionId: string
  fields: Record<string, unknown>
  items?: Record<string, unknown>[]
  sourceUrl: string
  hp: string
}

export async function submitToolResult(payload: ToolSubmissionPayload): Promise<void> {
  const response = await fetch("/wp-json/rsrh/submit", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(payload),
  })
  if (!response.ok) {
    throw new Error(`/wp-json/rsrh/submit responded with ${response.status}`)
  }
}

export type ToolResultResponse =
  | { found: true; fields: Record<string, unknown>; items: Record<string, unknown>[] }
  | { found: false }

// Reads back a previously-submitted result (e.g. for a "view your shared result" ?id= link).
// Field/item shapes are whatever that tool saved — the caller knows how to interpret its own data.
export async function getToolResult(tool: string, sessionId: string): Promise<ToolResultResponse> {
  const response = await fetch(
    `/wp-json/rsrh/result?tool=${encodeURIComponent(tool)}&sessionId=${encodeURIComponent(sessionId)}`,
  )
  if (!response.ok) {
    throw new Error(`/wp-json/rsrh/result responded with ${response.status}`)
  }
  return response.json()
}
